import { motion } from 'framer-motion';
import PortalShell from '@/components/PortalShell';
import AutoCursor from '@/components/AutoCursor';

export default function ReportPortalScene({ onNext }) {
  // Sidebar "Report Issue" footer button lives roughly at (x≈125, y≈585)
  // relative to the whole portal-shell wrapper.
  const cursorPath = [
    { x: 700, y: 350, delay: 1.2 },                   // start mid-content
    { x: 125, y: 585, delay: 1.8, click: true },      // glide to sidebar Report Issue
  ];

  return (
    <PortalShell
      activeItem="User"
      reportActive
      onReportClick={onNext}
      fullOverlay={<AutoCursor targets={cursorPath} startDelay={0.6} />}
    >
      <div data-testid="scene-report-portal" className="flex-1 flex items-center justify-center h-full px-8">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="text-center max-w-xl"
        >
          <h1 className="font-heading font-extrabold text-4xl tracking-tight text-[#0A0A0A] uppercase mb-4">
            Shafafiya Portal Home
          </h1>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.9 }}
            className="font-body text-base text-[#374151] leading-relaxed mb-3"
          >
            Shafafiya users can report any issue they encounter in the portal
            to the <span className="font-semibold text-teal-700">support team</span> to look into and resolve.
          </motion.p>
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.3 }}
            className="font-body text-sm text-[#737373] leading-relaxed"
          >
            They click <span className="font-bold text-teal-700">&ldquo;Report Issue&rdquo;</span> in the sidebar to file a complaint.
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0, x: [0, -8, 0, -8, 0] }}
            transition={{ opacity: { delay: 1.8 }, x: { duration: 1.4, delay: 2.6, repeat: Infinity, repeatType: 'loop' } }}
            className="mt-6 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-teal-50 border border-teal-200 text-[12px] font-body text-teal-800"
          >
            <span className="w-2 h-2 rounded-full bg-teal-600 animate-pulse" />
            ← Look at the bottom-left sidebar
          </motion.div>
        </motion.div>
      </div>
    </PortalShell>
  );
}
